import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getEnvQueryDetails = () => {
  const url = API_URLS.environmentalQuery;
  return axiosClient.get(url);
};

export const downloadLink = (vin) => {
  return `https://mbbublob.blob.core.chinacloudapi.cn/document/${vin}.pdf`;
};
